/* Elanessa: our-survey behaviour. Moved out of the section's inline <script> on 2026-09-03 so it
   loads deferred and cached instead of running mid-parse. One init per root element;
   re-runs for sections added in the theme editor. */
(function () {
  function init(root) {
    if (!root || root.dataset.init) return;
    root.dataset.init = '1';

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function run() {
      root.querySelectorAll('[data-animate-number]').forEach(function (el) {
        var target = parseFloat(el.dataset.target) || 0;
        var suffix = el.dataset.suffix || '';
        if (reduce) { el.textContent = target + suffix; return; }
        var start = null, dur = 1400;
        function step(ts) {
          if (!start) start = ts;
          var p = Math.min((ts - start) / dur, 1);
          el.textContent = Math.round(target * (1 - Math.pow(1 - p, 3))) + suffix;
          if (p < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      });
      root.querySelectorAll('[data-progress-bar]').forEach(function (el) {
        el.style.width = (parseFloat(el.dataset.fill) || 0) + '%';
      });
    }

    if (!('IntersectionObserver' in window)) { run(); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { run(); io.disconnect(); } });
    }, { threshold: 0.25 });
    io.observe(root);
  }
  function initAll(scope) {
    (scope || document).querySelectorAll('[data-elanessa-init="survey"]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
